import { Colors, Img, Lightning, Router, Utils } from '@lightningjs/sdk'
import { isString } from '../../lib/AppHelpers'

export default class SearchItem extends Lightning.Component {
  static _template() {
    return {
      w: 800,
      h: 195,
      CoverWrapper: {
        w: 150,
        h: 150,
        pivotX: 0,
        pivotY: 0,
        CoverImageWrapper: {
          w: 150,
          h: 150,
          Cover: { w: 150, h: 150 },
        },
        CoverBorder: {
          w: 150,
          h: 150,
          rect: true,
          shader: {
            radius: 5,
            stroke: 3,
            strokeColor: Colors('border')
              .alpha(0)
              .get(),
            fill: false,
            fillColor: 0x00000000,
            type: Lightning.shaders.RoundedRectangle,
          },
        },
      },
      InfoWrapper: {
        w: 630,
        x: 169,
        y: 23,
        Title: {
          w: 632,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            fontSize: 28,
            fontFace: 'OpenSansRegular',
            wordWrapWidth: 630,
            maxLines: 1,
            textOverflow: 'ellipsis',
          },
        },
        Author: {
          w: 632,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('author'),
            fontSize: 22,
            fontFace: 'OpenSansLight',
            wordWrap: false,
            maxLines: 0,
            textOverflow: 'ellipsis',
          },
        },
      },
      BottomLine: {
        w: 800,
        h: 2,
        y: 190,
        rect: true,
        color: Colors('white').get(),
      },
    }
  }

  set item(itm) {
    this._item = itm
  }

  get item() {
    return this._item
  }

  _init() {
    this._expanded = false

    this.tag('Title').on('txLoaded', () => {
      this.tag('Author').y = this.tag('Title').finalH + 10
    })

    this.tag('Cover').on('txError', () => {
      this.tag('Cover').texture = Img(Utils.asset('images/covers/ImagePlaceHolder.jpg')).cover(
        150 / 2,
        150 / 2
      ) // todo resize to original
    })
  }

  _firstActive() {
    this._update()
  }

  _update() {
    let title = this._item.title,
      author = this._item.itunesAuthor

    this.patch({
      CoverWrapper: {
        CoverImageWrapper: {
          Cover: { texture: Img(this._item.imageUrl).cover(150 / 2, 150 / 2) }, // todo resize to original
        },
      },
      title,
      author,
    })

    if (this._item.imageUrl === undefined || !isString(this._item.imageUrl)) {
      this.tag('Cover').texture = Img(Utils.asset('images/covers/ImagePlaceHolder.jpg')).cover(
        150 / 2,
        150 / 2
      ) // todo resize to original
    }
  }

  _showLargeSmall(bool) {
    this._expanded = bool

    let transition = { duration: 0.3, delay: 0, timingFunction: 'ease-in' }
    let transition2 = { duration: 0.3, delay: 0, timingFunction: 'ease-in' }
    let transition4 = { duration: 0.4, timingFunction: 'ease-in' }

    const itemWidth = bool === true ? 800 : 800
    const itemHeight = bool === true ? 320 : 195
    const scale = bool === true ? 1.7 : 1
    const stroke = bool === true ? 1 : 0
    const infoWrapperWidth = bool === true ? 565 : 630
    const infoWrapperX = bool === true ? 285 : 169
    const infoWrapperY = bool === true ? -7 : 23
    const authorWidth = bool === true ? 560 : 632
    const authorFontSize = bool === true ? 28 : 22
    const titleWidth = bool === true ? 560 : 632
    const titleFontSize = bool === true ? 35 : 28
    const titleFontFace = bool === true ? 'OpenSansBold' : 'OpenSansRegular'
    const titleMaxLines = bool === true ? 2 : 1
    const bottomLineHeight = bool === true ? 3 : 2
    const bottomLineY = bool === true ? 315 : 190

    this.patch({
      w: itemWidth,
      h: itemHeight,
      CoverWrapper: {
        smooth: { scale: [scale, transition2] },
        CoverBorder: { smooth: { 'shader.strokeColor': [stroke, transition4] } },
      },
      InfoWrapper: {
        smooth: {
          w: [infoWrapperWidth, transition],
          x: [infoWrapperX, transition],
          y: [infoWrapperY, transition],
        },
        Author: {
          w: authorWidth,
          text: { fontSize: authorFontSize },
        },
        Title: {
          w: titleWidth,
          text: {
            fontSize: titleFontSize,
            fontFace: titleFontFace,
            maxLines: titleMaxLines,
          },
        },
      },
      BottomLine: {
        smooth: {
          w: [itemWidth, transition2],
          h: [bottomLineHeight, transition2],
          y: [bottomLineY, transition2],
        },
      },
    })
  }

  _focus() {
    this._showLargeSmall(true)
    this.tag('CoverBorder').patch({
      smooth: {
        'shader.strokeColor': [
          Colors('border')
            .alpha(1)
            .get(),
          { duration: 0.4, timingFunction: 'ease-in' },
        ],
      },
    })
  }

  _unfocus() {
    this._showLargeSmall(false)
    this.tag('CoverBorder').patch({
      smooth: {
        'shader.strokeColor': [
          Colors('border')
            .alpha(0)
            .get(),
          { duration: 0.4, timingFunction: 'ease-in' },
        ],
      },
    })
  }

  get cellSizes() {
    return this.sizes
  }

  _handleEnter() {
    if (this._item.type === 'podcast') {
      Router.navigate(`podcastDetails/${this._item.id}`)
    } else if (this._item.type === 'podcast' || this._item.type === 'playlist') {
      Router.navigate(`playlistDetails/${this._item.id}`)
    }
  }
}
